const storage = window.sessionStorage;

const isEmpty = () => {
  if (storage.getItem("rates") === null) return true;
  return false;
};

const getRates = () => JSON.parse(storage.getItem("rates"));

const setRates = (rates) => storage.setItem("rates", JSON.stringify(rates));

const clearRates = () => storage.clear();

export {
  isEmpty,
  getRates,
  setRates,
  clearRates
};